import React, { useEffect, useState, useContext } from 'react';
import Spinner from 'react-bootstrap/Spinner';
import LocaleContext from 'constants/localization';

const Loading = () => {
  const [displayDelayDone, setDisplayDelayDone] = useState(false);
  const LS = useContext(LocaleContext);

  // 500 ms delay after mounting before loading indicator is displayed
  useEffect(() => {
    const timeout = setTimeout(() => setDisplayDelayDone(true), 500);
    return () => clearTimeout(timeout);
  }, []);

  if (displayDelayDone) {
    return (
      <Spinner animation="border" role="status">
        <span className="sr-only">{LS.loading}...</span>
      </Spinner>
    );
  }
  else {
    return null;
  }
};

export default Loading;